
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { t, i18n } = useTranslation('common');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'es' ? 'en' : 'es';
    i18n.changeLanguage(newLang);
  };

  const navLinks = [
    { name: t('nav_inicio'), href: '#inicio' },
    { name: t('nav_sobre_nosotros'), href: '#sobre-nosotros' },
    { name: t('nav_productos'), href: '#productos' },
    { name: t('nav_testimonios'), href: '#testimonios' },
    { name: t('nav_contacto'), href: '#contacto' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
      <div className="mx-6 sm:mx-8 lg:mx-12">
        <div className="flex items-center justify-between h-24">
          {/* Logo */}
          <a href="#inicio" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/44113e0bd02cf9d4b6e5b2a3bf2fb8ec/0aa4ae36cef4f32f6e620fc7b3ea763a.png"
              alt="La Bonita Market Logo"
              className="h-32 w-auto object-contain animate-float"
            />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-sm font-medium text-gray-700 transition-colors hover:text-red-600 whitespace-nowrap"
              >
                {link.name}
              </a>
            ))}
            
            {/* Language Switcher */}
            <button
              onClick={toggleLanguage}
              className="flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium bg-red-600 text-white hover:bg-red-700 transition-all hover:scale-105 whitespace-nowrap"
            >
              <i className="ri-global-line text-lg"></i>
              {i18n.language === 'es' ? 'English' : 'Español'}
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg text-gray-700 hover:bg-gray-100 transition-colors"
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white shadow-lg">
          <div className="px-6 py-4 space-y-3">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-gray-700 hover:text-red-600 font-medium transition-colors py-2"
              >
                {link.name}
              </a>
            ))}
            
            {/* Mobile Language Switcher */}
            <button
              onClick={() => {
                toggleLanguage();
                setIsMobileMenuOpen(false);
              }}
              className="w-full flex items-center justify-center gap-2 bg-red-600 text-white px-4 py-3 rounded-lg font-medium hover:bg-red-700 transition-all whitespace-nowrap"
            >
              <i className="ri-global-line text-lg"></i>
              {i18n.language === 'es' ? 'English' : 'Español'}
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
